import React, { useState } from 'react';
import './FeatureTree.css';

const FEATURE_ICONS = {
  SketchObject: '\u270F',
  Pad: '\u2B06',
  Pocket: '\u2B07',
  Revolution: '\u21BB',
  Fillet: '\u25EF',
  Chamfer: '\u25C7',
};

function FeatureTree({ featureTree, onFeatureClick, selectedBody, selectedFeature }) {
  const [collapsed, setCollapsed] = useState(false);
  const [expandedBodies, setExpandedBodies] = useState({});

  if (!featureTree || featureTree.length === 0) {
    return null;
  }

  const toggleBody = (name, e) => {
    e.stopPropagation();
    setExpandedBodies(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleBodyClick = (bodyName) => {
    if (onFeatureClick) onFeatureClick(bodyName, null);
  };

  const handleFeatureClick = (bodyName, featName, e) => {
    e.stopPropagation();
    if (onFeatureClick) onFeatureClick(bodyName, featName);
  };

  return (
    <div className={`feature-tree-panel ${collapsed ? 'collapsed' : ''}`}>
      <div className="feature-tree-header" onClick={() => setCollapsed(!collapsed)}>
        <span className="feature-tree-title">
          Feature Tree
        </span>
        <span className={`feature-tree-toggle ${collapsed ? 'collapsed' : ''}`}>
          {collapsed ? '\u25B6' : '\u25BC'}
        </span>
      </div>

      {!collapsed && (
        <div className="feature-tree-content">
          {featureTree.map((body) => {
            const isExpanded = expandedBodies[body.name] !== false;
            const isBodySelected = selectedBody === body.name && !selectedFeature;
            return (
              <div key={body.name} className="body-node">
                <div
                  className={`body-header ${isBodySelected ? 'selected' : ''}`}
                  onClick={() => handleBodyClick(body.name)}
                >
                  <span className="toggle" onClick={(e) => toggleBody(body.name, e)}>
                    {isExpanded ? '\u25BC' : '\u25B6'}
                  </span>
                  <span className="body-icon">{'\u2B1B'}</span>
                  <span className="body-name">{body.name}</span>
                </div>
                {isExpanded && (
                  <div className="features-list">
                    {body.features.map((feat, idx) => {
                      const icon = FEATURE_ICONS[feat.type] || '\u2022';
                      let detail = '';
                      if (feat.length) detail = `${feat.length}mm`;
                      if (feat.size) detail = `${feat.size}mm`;
                      if (feat.angle && feat.angle !== 360) detail = `${feat.angle}\u00B0`;
                      const isSelected = selectedBody === body.name && selectedFeature === feat.name;

                      return (
                        <div
                          key={idx}
                          className={`feature-node ${isSelected ? 'selected' : ''}`}
                          onClick={(e) => handleFeatureClick(body.name, feat.name, e)}
                        >
                          <span className="feature-icon">{icon}</span>
                          <span className="feature-name">{feat.name}</span>
                          <span className="feature-type">{feat.type}</span>
                          {detail && <span className="feature-detail">{detail}</span>}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default FeatureTree;
